<template>
    <div class="fatal">
        <img :src="IMAGE_MAP.NETWORK_ERROR_ICON">
        <h6>{{ message }}</h6>
        <a href="#" class="btn" @click.prevent="btnClick">
            {{ btnClose ? '关闭' : '重试' }}
        </a>
    </div>
</template>
<style lang="less" scoped>
@import '../assets/style/all.less';
@unit: 2px;

.fatal {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #fff;
    img {
        width: 136 / @unit;
        height: 136 / @unit;
        border: 0;
        display: block;
    }
    h6 {
        font-size: 28 / @unit;
        color: #c6c6c6;
        line-height: 38 / @unit;
        font-weight: normal;
        margin: 24 / @unit 32 / @unit 64 / @unit;
    }
    .btn {
        color: #fff;
        text-align: center;
        background: @brand-color;
        border: 0;
        outline: 0;
        margin: 0;
        box-sizing: border-box;
        font-size: 28 / @unit;
        width: 250 / @unit;
        height: 72 / @unit;
        line-height: 72 / @unit;
        border-radius: 8 / @unit;
        text-decoration: none;
    }
}
</style>

<script>
/**
 * 展示关闭按钮的状态：
 * 270011 未登录
 * 280003 业务已下线
 */
const CLOSE_CODES = [270011, 280003];
import { getFixedImgUrl } from '@/utils/dynamic-cdn';
const IMAGE_MAP = getFixedImgUrl();
export default {
    name: 'fatal',
    props: {
        message: {
            type: String,
            default: '未知错误',
        },
        code: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return { IMAGE_MAP };
    },
    computed: {
        btnClose() {
            return CLOSE_CODES.includes(this.code);
        },
    },
    methods: {
        btnClick() {
            if (this.btnClose) {
                this.$emit('close');
            } else {
                this.$emit('retry');
            }
        },
    },
};
</script>


